export const aboutData = {
  brand: {
    title: "关于17c一起草",
    subtitle: "致力于为用户提供最优质的官方导航服务",
    description: "17c一起草官网入口是经官方认证的正版直达通道，自成立以来始终秉持「用户至上、安全第一」的理念，为数百万用户提供稳定、安全、高效的官方网站访问服务。我们深知用户在寻找官方入口时面临的困扰 —— 失效链接、仿冒网站、访问缓慢等问题，因此17c一起草官网入口致力于成为用户最信赖的官方导航平台。",
    mission: "让每一位用户都能快速、安全地找到17c一起草官方网站入口",
    vision: "成为用户心中最可靠的官方入口导航平台",
  },
  timeline: [
    { year: "2018", event: "17c一起草平台正式上线运营" },
    { year: "2019", event: "推出官方入口导航服务，帮助用户快速找到官方网站" },
    { year: "2020", event: "用户突破100万，上线镜像入口功能" },
    { year: "2021", event: "移动端适配完成，全面支持手机和平板设备" },
    { year: "2022", event: "安全防护系统升级，引入智能风险识别技术" },
    { year: "2023", event: "用户突破300万，成为行业领先的官方导航平台" },
    { year: "2024", event: "性能全面优化，页面加载速度提升50%" },
    { year: "2025", event: "全新品牌升级，推出智能化入口推荐功能" },
    { year: "2026", event: "用户突破500万，持续优化17c一起草官网入口服务体验" },
  ],
  reputation: {
    title: "品牌信誉",
    subtitle: "17c一起草官网入口用实力赢得用户信赖",
    items: [
      {
        icon: "ri-medal-line",
        title: "官方认证资质",
        description: "17c一起草官网入口已通过多项行业权威认证，所有入口链接均经过官方授权和严格审核，确保您访问的是真正的17c一起草官方网站。",
      },
      {
        icon: "ri-user-heart-line",
        title: "用户口碑见证",
        description: "超过500万用户选择通过17c一起草官网入口访问官方网站，用户满意度持续保持在98%以上，口碑是最好的信任证明。",
      },
      {
        icon: "ri-building-2-line",
        title: "长期稳定运营",
        description: "自2018年成立以来，17c一起草官网入口已稳定运营超过8年，积累了丰富的行业经验和用户服务能力。",
      },
      {
        icon: "ri-hand-heart-line",
        title: "诚信服务承诺",
        description: "我们承诺永远免费为用户提供17c一起草官网入口导航服务，不捆绑、不强制、不误导，让用户自主选择。",
      },
    ],
  },
  contact: {
    title: "联系我们",
    subtitle: "如果您在使用17c一起草官网入口过程中遇到任何问题，欢迎随时联系我们",
    email: "support@17c-yiqicao.com",
    phone: "400-XXX-XXXX",
    workingHours: "周一至周日 9:00 - 21:00",
    address: "中国",
  },
};